let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iMNWr")).then(() => parcelRequire('6Czli'));